export const TENANT_UPDATE_TENANT = 'TENANT_UPDATE_TENANT'
export const TENANT_UPDATE_TENANT_BASIC_INFORMATION = 'TENANT_UPDATE_TENANT_BASIC_INFORMATION'
export const TENANT_UPDATE_YEARS_LIST = 'TENANT_UPDATE_YEARS_LIST'
export const TENANT_UPDATE_YEARS_LIST_METHOD = 'TENANT_UPDATE_YEARS_LIST_METHOD'
export const TENANT_UPDATE_ANALYTICS_CHARTS_LIST = 'TENANT_UPDATE_ANALYTICS_CHARTS_LIST'
export const TENANT_UPDATE_ANALYTICS_CHARTS_LIST_METHOD = 'TENANT_UPDATE_ANALYTICS_CHARTS_LIST_METHOD'
export const TENANT_UPDATE_API_SERVICES_LIST = 'TENANT_UPDATE_API_SERVICES_LIST'
export const TENANT_UPDATE_API_SERVICES_LIST_METHOD = 'TENANT_UPDATE_API_SERVICES_LIST_METHOD'
export const TENANT_UPDATE_TERM_LIST = 'TENANT_UPDATE_TERM_LIST'
export const TENANT_UPDATE_TERM_LIST_METHOD = 'TENANT_UPDATE_TERM_LIST_METHOD'
export const TENANT_UPDATE_TERM_ACTIVE = 'TENANT_UPDATE_TERM_ACTIVE'
export const TENANT_UPDATE_SSO_LIST = 'TENANT_UPDATE_SSO_LIST'
export const TENANT_UPDATE_SSO_LIST_METHOD = 'TENANT_UPDATE_SSO_LIST_METHOD'
export const TENANT_UPDATE_FLAGS_LIST = 'TENANT_UPDATE_FLAGS_LIST'
export const TENANT_UPDATE_FLAGS_LIST_METHOD = 'TENANT_UPDATE_FLAGS_LIST_METHOD'
// MF-528 — feature flags (the whole featureFlag object is replaced after each change)
export const TENANT_UPDATE_FEATURE_FLAG = 'TENANT_UPDATE_FEATURE_FLAG'
// MF-67 — school geo centre { lat, lng }
export const TENANT_UPDATE_GEO = 'TENANT_UPDATE_GEO'
export const TENANT_UPDATE_THIRD_PARTY_ACCESS_LIST = 'TENANT_UPDATE_THIRD_PARTY_ACCESS_LIST'
export const TENANT_UPDATE_THIRD_PARTY_ACCESS_LIST_METHOD = 'TENANT_UPDATE_THIRD_PARTY_ACCESS_LIST_METHOD'

// Tenant
export const updateTenant = (data = {}) => ({
  type: TENANT_UPDATE_TENANT,
  payload: { data }
})
export const updateTenantBasicInformation = (data = {}) => ({
  type: TENANT_UPDATE_TENANT_BASIC_INFORMATION,
  payload: { data }
})
export const updateTenantGeo = (geo = {}) => ({
  type: TENANT_UPDATE_GEO,
  payload: { geo }
})

// Years
export const updateYearsList = (data = []) => ({
  type: TENANT_UPDATE_YEARS_LIST,
  payload: { data }
})
export const updateYearsListMethod = (method = 'POST', data) => ({
  type: TENANT_UPDATE_YEARS_LIST_METHOD,
  payload: { method, data }
})

// Analytics charts
export const updateAnalyticsChartsList = (data = []) => ({
  type: TENANT_UPDATE_ANALYTICS_CHARTS_LIST,
  payload: { data }
})
export const updateAnalyticsChartsListMethod = (method = 'POST', data) => ({
  type: TENANT_UPDATE_ANALYTICS_CHARTS_LIST_METHOD,
  payload: { method, data }
})

// Api services
export const updateApiServicesList = (data = []) => ({
  type: TENANT_UPDATE_API_SERVICES_LIST,
  payload: { data }
})
export const updateApiServicesListMethod = (method = 'POST', data) => ({
  type: TENANT_UPDATE_API_SERVICES_LIST_METHOD,
  payload: { method, data }
})

// Term
export const updateTermsList = (data = []) => ({
  type: TENANT_UPDATE_TERM_LIST,
  payload: { data }
})
export const updateTermsListMethod = (method = 'POST', data) => ({
  type: TENANT_UPDATE_TERM_LIST_METHOD,
  payload: { method, data }
})
export const updateTermActive = (data = {}) => ({
  type: TENANT_UPDATE_TERM_ACTIVE,
  payload: { data }
})

// SSO
export const updateSSOList = (data = []) => ({
  type: TENANT_UPDATE_SSO_LIST,
  payload: { data }
})
export const updateSSOListMethod = (method = 'POST', data) => ({
  type: TENANT_UPDATE_SSO_LIST_METHOD,
  payload: { method, data }
})

// Flags
export const updateFlagsList = (data = []) => ({
  type: TENANT_UPDATE_FLAGS_LIST,
  payload: { data }
})
export const updateFlagsListMethod = (method = 'POST', data) => ({
  type: TENANT_UPDATE_FLAGS_LIST_METHOD,
  payload: { method, data }
})

// Third party access (external credentials)
export const updateThirdPartyAccessList = (data = []) => ({
  type: TENANT_UPDATE_THIRD_PARTY_ACCESS_LIST,
  payload: { data }
})
export const updateThirdPartyAccessListMethod = (method = 'POST', data) => ({
  type: TENANT_UPDATE_THIRD_PARTY_ACCESS_LIST_METHOD,
  payload: { method, data }
})

// MF-528 — replace the tenant's featureFlag object (after toggling/creating/deleting a flag).
// `meta` (optional) replaces featureFlagMeta (custom-flag descriptions) when provided.
export const updateFeatureFlag = (data = {}, meta) => ({
  type: TENANT_UPDATE_FEATURE_FLAG,
  payload: { data, meta }
})
